import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import { i18n } from '../../translate/i18n';
import {
  Container, Button, CssBaseline,
  TextField,
  Grid,
  CircularProgress
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  NavLinkStyled,
  LogoText,
  Appbar,
} from './styles';
import CheckCircle from "@mui/icons-material/CheckCircle";

import { emailValidator } from '../../utils/emailValidator';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: 150,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "green",
    '&:hover': {
      backgroundColor: "green",
      opacity: .90,
    },
  },
}));

export default function ForgotPasswordConfirmation(props) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [email, setEmail] = useState("");
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false)

  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [emailError, setEmailError] = useState(false);

  const [passwordError, setPasswordError] = useState(false);
  const [passwordConfirmationError, setPasswordConfirmationError] = useState(false);

  const forgotPasswordActivate = (body) => dispatch(actions.forgotPasswordActivate(props.match.params.id, body))
  const loadingUser = useSelector(state => state.users.loading);

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!emailValidator(email)) {
      setEmailError(true)
      hasError = true;
    }

    if (!validPassword()) {
      hasError = true;
    }

    if (hasError) return;

    let body = {
      email,
      password
    }

    forgotPasswordActivate(body).then((response) => {
      if (response === 'success') {
        setForgotPasswordSuccess(true);
      }
    })

  }

  const validPassword = () => {
    if (password.length < 6) {
      setPasswordError(true)
      return false;
    }
    return true;
  }


  const onChangePassword = (event) => {
    if (passwordError && event.target.value.length >= 6) {
      setPasswordError(false);
    }
    setPasswordConfirmation("")
    return setPassword(event.target.value)
  }

  const onChangePasswordConfirmation = (event) => {
    if (password === event.target.value) {
      setPasswordConfirmationError(false);
    }
    return setPasswordConfirmation(event.target.value)
  }

  const validPasswordConfirmation = () => {
    if (password === passwordConfirmation) {
      return true;
    } else {
      setPasswordConfirmationError(true)
      return false;
    }
  }


  return (
    <>
      <Appbar />
      <Container component="main" maxWidth="xs" style={{ marginBottom: '100px' }}>
        <CssBaseline />
        {!forgotPasswordSuccess && (
          <div className={classes.paper}>
            <LogoText />
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label={i18n.t('textFieldForgotPasswordConfirm.email')}
                    name="email"
                    autoComplete="email"
                    value={email}
                    error={emailError}
                    onChange={event => setEmail(event.target.value.toLowerCase())}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="password"
                    label={i18n.t('textFieldForgotPasswordConfirm.password')}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    helperText={i18n.t('textFieldForgotPasswordConfirm.helperText')}
                    error={passwordError}
                    onChange={event => onChangePassword(event)}
                    onBlur={validPassword}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="confirmPassword"
                    label={i18n.t('textFieldForgotPasswordConfirm.confirmPassword')}
                    type="password"
                    id="confirmPassword"
                    autoComplete="confirm-password"
                    value={passwordConfirmation}
                    error={passwordConfirmationError}
                    onChange={event => onChangePasswordConfirmation(event)}
                    helperText={passwordConfirmationError && i18n.t('textFieldForgotPasswordConfirm.passwordError')}
                    onBlur={validPasswordConfirmation}
                  />
                </Grid>

              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={loadingUser}
                startIcon={loadingUser && <CircularProgress />}
              >
                {i18n.t('buttonForgotPassConfirm.text')}
          </Button>
            </form>
          </div>)}
        {forgotPasswordSuccess && (
          <div className={classes.paper}>

            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%", height: "100%" }}>
              <CheckCircle style={{ height: "100px", width: "100px", color: "green" }} />
              <div style={{ fontSize: "25px", fontWeight: 'bold', textAlign: "center" }}>{i18n.t('divForgotPassConfirm.text')}</div>
              <NavLinkStyled variant="body2" to='/login'>{i18n.t('navLinkStyledFPC.text')}</NavLinkStyled>
            </div>
          </div>
        )}
      </Container>
    </>
  );
}
